"use strict";

import { Collection } from "Collection";
import { FormGroupsModel } from 'Models/FormGroupsModel';
import { Objects } from "Constants/objects";
export var FormGroupsCollection = Collection.extend({
  model: FormGroupsModel,
  object: Objects.SysFormGroups
});